import { supabaseClient } from "@/lib/supabase";

export async function deleteShockwaveDetails(shockwaveId: string) {
	const { data, error } = await supabaseClient.from("shockwave_details")
		.delete().eq("shockwave_id", shockwaveId);
	if (error) throw error;
	return data;
}
